/**
 * Product-level build flavor.
 *
 * The default keeps the existing combined site behavior. Salt and Apple builds
 * share the same data, playback and API layers and only lock presentation.
 */
export type ProductFlavor = 'combined' | 'salt' | 'apple';

const rawFlavor = String(import.meta.env.VITE_PRODUCT_FLAVOR || '').trim().toLowerCase();

export const productFlavor: ProductFlavor = rawFlavor === 'salt' || rawFlavor === 'apple' ? rawFlavor : 'combined';
export const saltOnly = productFlavor === 'salt';
export const appleOnly = productFlavor === 'apple';
export const independentProduct = saltOnly || appleOnly;
export const lockedAppearance: 'salt' | 'apple' | null = saltOnly ? 'salt' : appleOnly ? 'apple' : null;
export const lockedPageStyle: 'salt' | 'apple' | null = lockedAppearance;
